<template functional>
    <div class="ur-data-grid__content__cell__value" :style="$options.style.valueStyle({props,injections})"
         v-ur-tooltip.overflow.empty="props.text" v-if="!$options.util.isEmpty(props.text)">{{props.text}}</div>
</template>



<script>
export default {
    name : "urDataGridContentCellValue",
    inject : ['gridInfo'],
    props : {
        field : {type:Object},
        text : null /* type any */
    },
    style:{ /* STYLE methods :  It's not a standard KEYWORD!*/
        // [STYLE] Value cell style
        valueStyle({props,injections}) {
            return {}
        }
    },
    util: { /* UTIL methods :  It's not a standard KEYWORD!*/
        // [UTIL] Is empty
        isEmpty(val) {
            return val === undefined || val === null || val === ''
        }
    }
}
</script>